import { FormHelperText, FormLabel } from '@mui/material';

import {
  CoreBox,
  CoreFormControl,
  CoreFormControlLabel,
  CoreRadio,
  CoreRadioGroup,
  CoreTypography,
} from '@youscience/core';

import ActionButton from '@components/ActionButton';
import { StyledFieldWrapper } from './RadioGroupWithClearbutton.styles';

interface RadioButtonGroupWithClearButtonProps {
  name: string;
  title: string;
  value: string | boolean | undefined | null;
  options: { [key: string]: string };
  required?: boolean;
  handleRadioChange: (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClear: () => void;
  error?: boolean;
  helperText?: string;
  testId?: string;
}

export const RadioButtonGroupWithClearButton = ({
  name,
  title,
  value,
  options,
  required,
  handleRadioChange,
  handleClear,
  error,
  helperText,
  testId,
}: RadioButtonGroupWithClearButtonProps) => {
  return (
    <StyledFieldWrapper>
      <CoreTypography variant="subtitle2" component="h4">
        {title}
      </CoreTypography>

      <CoreFormControl error={error} data-testid={testId}>
        <FormLabel id={`${name}Label`}>Select your option {required ? '*' : ''}</FormLabel>
        <CoreRadioGroup
          aria-labelledby={`${name}Label`}
          name={name}
          onChange={handleRadioChange(name)}
          value={value ?? null}
        >
          {Object.entries(options).map(([key, value]) => {
            return <CoreFormControlLabel key={value} value={value} control={<CoreRadio />} label={key} />;
          })}
        </CoreRadioGroup>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </CoreFormControl>

      <CoreBox>
        <ActionButton variant="outlined" onClick={handleClear}>
          Clear answer
        </ActionButton>
      </CoreBox>
    </StyledFieldWrapper>
  );
};
